import { render } from "./user-role.vue?vue&type=template&id=682de3c2&scoped=true"
import script from "./user-role.vue?vue&type=script&lang=js"
export * from "./user-role.vue?vue&type=script&lang=js"

import "./user-role.vue?vue&type=style&index=0&id=682de3c2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682de3c2"]])

export default __exports__